<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../../../components/LoadingSpinner.svelte';
  import SlaTaskForm from './SlaTaskForm.svelte';

  import type { SlaTaskAssociation, SlaTaskRow } from '../../../../shared/types/sla-task-types';

  type InitialValues = {
    id?: string;
    associations: SlaTaskAssociation[];
  };

  export let open = false,
    data: SlaTaskRow | null = null;

  const dispatch = createEventDispatcher<{ close: { action: string; data: SlaTaskRow } | undefined }>();

  let formSubmitButtonRef: HTMLElement | undefined,
    loading = false;

  function onModalSubmit() {
    if (!formSubmitButtonRef) {
      throw new Error('Form submit button not found!');
    }

    formSubmitButtonRef.click();
  }

  function onFormSubmit(event: CustomEvent<{ action: string; data: SlaTaskRow }>) {
    dispatch('close', event.detail);
  }

  function onModalClose() {
    dispatch('close');
  }

  $: initialValues = {
    id: data?.id,
    associations: (data?.associations ?? []).map((association) => ({
      feedId: association.feedId,
      serviceId: association.serviceId,
      marketDayOffset: association.marketDayOffset,
    })),
  } as InitialValues;
</script>

<Modal
  bind:open
  size="lg"
  modalHeading="Edit Associations"
  modalLabel={data?.friendlyName ?? ''}
  preventCloseOnClickOutside
  primaryButtonText="Save"
  primaryButtonDisabled={loading}
  secondaryButtonText="Cancel"
  shouldSubmitOnEnter={false}
  on:close={onModalClose}
  on:click:button--secondary={onModalClose}
  on:submit={onModalSubmit}
>
  <LoadingSpinner {loading}>
    <SlaTaskForm variant="edit-associations" bind:formSubmitButtonRef bind:loading {initialValues} on:submit={onFormSubmit} />
  </LoadingSpinner>
</Modal>
